import React from "react";
import axios from "axios";
import { useState } from "react";
import { baseurl } from "../../constant";
const OpenMoneyPayoutDocument = ({ openPayoutCallbackUrl }) => {
  const [data, setdats] = useState();
  const [url, setUrl] = useState();

  const token = localStorage.getItem("authToken");

  const submitCallbackurl = async () => {
    const result = await axios.post(baseurl + "callbackUpdateAuth", {
      token: token,
      type: 3,
      url: url,
    });
    setdats(result.data);
  };

  return (
    <div className="card shadow mb-4">
      <form
        id="admin_profile"
        enctype="multipart/form-data"
        method="post"
        accept-charset="utf-8"
      />
      <input type="hidden" name="method" value="post" />
      <div className="card-header py-3">
        {data && (
          <h4
            style={{
              backgroundColor: "#d2f4e8",
              borderColor: "#bff0de",
              color: "green",
            }}
          >
            {data.message}
          </h4>
        )}
        <div className="row">
          <div className="col-sm-8">
            <h4>
              <b>Open Money Payout API Document</b>
            </h4>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-sm-12">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="beneficiary-tab"
                  data-toggle="tab"
                  href="#beneficiary"
                  role="tab"
                  aria-controls="beneficiary"
                  aria-selected="true"
                >
                  Add Account Beneficiary Api
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="beneficiary-list-tab"
                  data-toggle="tab"
                  href="#beneficiary-list"
                  role="tab"
                  aria-controls="beneficiary-list"
                  aria-selected="true"
                >
                  {" "}
                  Account Beneficiary List
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="vpa-beneficiary-tab"
                  data-toggle="tab"
                  href="#vpa-beneficiary"
                  role="tab"
                  aria-controls="vpa-beneficiary"
                  aria-selected="true"
                >
                  {" "}
                  Add VPA Beneficiary
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="vpa-beneficiary-list-tab"
                  data-toggle="tab"
                  href="#vpa-beneficiary-list"
                  role="tab"
                  aria-controls="vpa-beneficiary-list"
                  aria-selected="true"
                >
                  {" "}
                  VPA Beneficiary List
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="open-money-payout-tab"
                  data-toggle="tab"
                  href="#open-money-payout-list"
                  role="tab"
                  aria-controls="open-money-payout"
                  aria-selected="true"
                >
                  Bank Account Payout
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="open-money-upi-payout-tab"
                  data-toggle="tab"
                  href="#open-money-upi-payout-list"
                  role="tab"
                  aria-controls="open-money-upi-payout"
                  aria-selected="true"
                >
                  UPI Payout
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="callBack-tab"
                  data-toggle="tab"
                  href="#callBack"
                  role="tab"
                  aria-controls="callBack"
                  aria-selected="false"
                >
                  Call Back URL
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="checkStatus-tab"
                  data-toggle="tab"
                  href="#checkStatus"
                  role="tab"
                  aria-controls="checkStatus"
                  aria-selected="true"
                >
                  Status Check API
                </a>
              </li>
            </ul>
            <div className="tab-content apidoc" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="beneficiary"
                role="tabpanel"
                aria-labelledby="rechargeAPI-tab"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontSeight: "bold" }}>
                    https://www.payol.in/portal/api/addBeneficiary
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    {/* <!-- <tr>
                  <td>1.</td>
                  <td>mobile</td>
                  <td>Customer Mobile No.</td>
                </tr> --> */}
                    <tr>
                      <td>1.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>account_no</td>
                      <td>Customer Account No.</td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>ifsc</td>
                      <td>Customer Bank IFSC Code.</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>email</td>
                      <td>Beneficiary's email</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>mobile</td>
                      <td>Beneficiary's mobile</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>txnID</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"}
                    <br />
                    "status_code": 200,
                    <br /> "status_msg": "OK",
                    <br /> "status": "SUCCESS",
                    <br /> "bene_id": "vab_4585414585251252",
                    <br /> "txnid": 16131198309337,
                    <br /> "account_holder_name": "TestName",
                    <br /> "account_number": "1221108115222",
                    <br /> "ifsc": "PUNB0874500",
                    <br /> "email": "test@gmail.com", <br />
                    "mobile": 8541521285,
                    <br /> "opt_msg": "Transaction Successful"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name.</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>account_number</td>
                      <td>Account Number.</td>
                    </tr>

                    <tr>
                      <td>8.</td>
                      <td>ifsc</td>
                      <td>IFSC.</td>
                    </tr>

                    <tr>
                      <td>9.</td>
                      <td>email</td>
                      <td> Beneficiary Email.</td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>mobile</td>
                      <td>Beneficiary Mobile.</td>
                    </tr>

                    <tr>
                      <td>11.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="beneficiary-list"
                role="tabpanel"
                aria-labelledby="beneficiary-list-tab"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/beneficiaryList
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>transaction_id</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"}
                    <br />
                    "status_code": 200,
                    <br /> "status_msg": "OK", <br />
                    "status": "SUCCESS", <br />
                    "bene_id" : "vab_4585414585251252", <br />
                    "txnid": 16131198309337, <br />
                    "account_holder_name" : "Test Name",
                    <br />
                    "account_number":"1221108115222", <br />
                    "ifsc":"PUNB0874500",
                    <br />
                    "email" : "test@gmail.com", <br />
                    "mobile" : "8541521285",
                    <br />
                    "opt_msg" : "Transaction Successful"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name.</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>account_number</td>
                      <td>Account Number.</td>
                    </tr>

                    <tr>
                      <td>8.</td>
                      <td>ifsc</td>
                      <td>IFSC.</td>
                    </tr>

                    <tr>
                      <td>9.</td>
                      <td>email</td>
                      <td> Beneficiary Email.</td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>mobile</td>
                      <td>Beneficiary Mobile.</td>
                    </tr>

                    <tr>
                      <td>11.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="vpa-beneficiary-list"
                role="tabpanel"
                aria-labelledby="vpa-beneficiary-list-tab"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/vpaBeneficiaryList
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>transaction_id</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"}
                    <br /> "status_code": 200, <br />
                    "status_msg": "OK",
                    <br /> "status": "SUCCESS", <br />
                    "bene_id" : "vab_4585414585251252",
                    <br /> "txnid": 16131198309337, <br />
                    "account_holder_name" : "Test Name",
                    <br /> "account_number":"1221108115222", <br />
                    "ifsc":"PUNB0874500",
                    <br />
                    "email" : "test@gmail.com", <br />
                    "mobile" : "8541521285",
                    <br />
                    "opt_msg" : "Transaction Successful"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name.</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>account_number</td>
                      <td>Account Number.</td>
                    </tr>

                    <tr>
                      <td>8.</td>
                      <td>email</td>
                      <td> Beneficiary Email.</td>
                    </tr>

                    <tr>
                      <td>9.</td>
                      <td>mobile</td>
                      <td>Beneficiary Mobile.</td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="vpa-beneficiary"
                role="tabpanel"
                aria-labelledby="vpa-beneficiary"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/addVpaBeneficiary
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ Color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    {/* <!-- <tr>
                  <td>1.</td>
                  <td>mobile</td>
                  <td>Customer Mobile No.</td>
                </tr> --> */}
                    <tr>
                      <td>1.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>account_no</td>
                      <td>Customer Vpa Address.</td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>email</td>
                      <td>Beneficiary's email</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>mobile</td>
                      <td>Beneficiary's mobile</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>txnID</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"}
                    <br />
                    "status_code": 200,
                    <br /> "status_msg": "OK", <br />
                    "status": "SUCCESS",
                    <br /> "bene_id" : "vab_4585414585251252",
                    <br /> "txnid": 16131198309337, <br />
                    "account_holder_name" : "Test Name",
                    <br /> "account_number":"1221108115222", <br />
                    "ifsc":"PUNB0874500",
                    <br />
                    "email" : "test@gmail.com", <br />
                    "mobile" : "8541521285",
                    <br />
                    "opt_msg" : "Transaction Successful"{"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name.</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>account_number</td>
                      <td>Account Number.</td>
                    </tr>

                    <tr>
                      <td>8.</td>
                      <td>email</td>
                      <td> Beneficiary Email.</td>
                    </tr>

                    <tr>
                      <td>9.</td>
                      <td>mobile</td>
                      <td>Beneficiary Mobile.</td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="open-money-payout-list"
                role="tabpanel"
                aria-labelledby="open-money-payout-list"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/openPayout
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>

                    <tr>
                      <td>1.</td>
                      <td>txnID</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>

                    <tr>
                      <td>2.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID(Get From Beneficiary List Api)</td>
                    </tr>

                    <tr>
                      <td>3.</td>
                      <td>amount</td>
                      <td>Amount</td>
                    </tr>

                    <tr>
                      <td>3.</td>
                      <td>payment_mode</td>
                      <td>Payment Mode (imps,neft,rtgs)</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"} <br />
                    "status_code": 200,
                    <br /> "status_msg": "OK",
                    <br /> "status": "SUCCESS", <br />
                    "bene_id" : "vab_4585414585251252",
                    <br /> "txnid": 16131198309337, <br />
                    "account_holder_name" : "Test Name",
                    <br />
                    "account_number":"1221108115222",
                    <br /> "ifsc":"PUNB0874500",
                    <br />
                    "email" : "test@gmail.com",
                    <br /> "mobile" : "8541521285",
                    <br />
                    "opt_msg" : "Transaction Successful"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>account_holder_name</td>
                      <td>Account Holder Name.</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>account_number</td>
                      <td>Account Number.</td>
                    </tr>

                    <tr>
                      <td>8.</td>
                      <td>ifsc</td>
                      <td>IFSC.</td>
                    </tr>

                    <tr>
                      <td>9.</td>
                      <td>email</td>
                      <td> Beneficiary Email.</td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>mobile</td>
                      <td>Beneficiary Mobile.</td>
                    </tr>

                    <tr>
                      <td>11.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="open-money-upi-payout-list"
                role="tabpanel"
                aria-labelledby="open-money-upi-payout-list"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/openUpiPayout
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>

                    <tr>
                      <td>1.</td>
                      <td>txnID</td>
                      <td>Unique Trasaction ID(Min Length 10 )</td>
                    </tr>

                    <tr>
                      <td>2.</td>
                      <td>bene_id</td>
                      <td>Beneficiary ID(Get From Beneficiary List Api)</td>
                    </tr>

                    <tr>
                      <td>3.</td>
                      <td>amount</td>
                      <td>Amount</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"} "status_code": 200,
                    <br /> "status_msg": "OK",
                    <br /> "status": "SUCCESS",
                    <br /> "txnid": 16131198309337, <br />
                    "rrn":432512524158 "orderID" : "85415212858545",
                    <br /> "opt_msg" : "Transaction Successful"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>

                    <tr>
                      <td>4.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>rrn</td>
                      <td>432512524158</td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td>orderID</td>
                      <td>85415212858545</td>
                    </tr>

                    <tr>
                      <td>7.</td>
                      <td>opt_msg</td>
                      <td>Opt Msg.</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="callBack"
                role="tabpanel"
                aria-labelledby="callBack-tab"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Update Callback URL</h1>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="open_payout_call_back_url"
                      placeholder={openPayoutCallbackUrl}
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={submitCallbackurl}
                    >
                      Save
                    </button>
                  </div>
                  <hr />
                  <p>
                    <b>Request Method - GET Format</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>GET Parameter</h1>
                  status=SUCCESS&txnid=1707798479&optxid=tr_7aqbokI4kJM1KHZD6dOSwVoka&amount=10&rrn=404409703139
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="checkStatus"
                role="tabpanel"
                aria-labelledby="checkStatus-tab"
              >
                <div className="col-sm-12">
                  <br />
                  <h1>Request API URL</h1>
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    https://www.payol.in/portal/api/openPayoutCheckStatus
                  </p>
                  <hr />
                  <p>
                    <b>Request Method - POST</b>
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Header Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>Memberid</td>
                      <td>Your account unique id.</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Txnpwd</td>
                      <td>Your account trasaction password.</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>
                <div className="col-sm-12">
                  <br />
                  <h1>Post Parameter</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    {/* <!-- <tr>
                  <td>1.</td>
                  <td>mobile</td>
                  <td>Customer Mobile No.</td>
                </tr> --> */}
                    <tr>
                      <td>1.</td>
                      <td>txnID</td>
                      <td>Your Unique Transcation ID</td>
                    </tr>
                  </table>
                  <p style={{ color: "red" }}>
                    Note:- All Parameter key are case sensitive.
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>JSON Response</h1>
                  <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                    {"{"}
                    <br /> "status_code": 200,
                    <br /> "status_msg": "OK",
                    <br /> "status": "SUCCESS",
                    <br /> "amount" : 100, <br />
                    "txnid": 16131198309337,
                    <br /> "rrn" : 302111739646,
                    <br /> "opt_msg" : "Transaction Fetch Successfully"
                    <br />
                    {"}"}
                  </p>
                </div>

                <div className="col-sm-12">
                  <br />
                  <h1>Response Parameters</h1>
                  <table className="table table-bordered table-striped">
                    <tr>
                      <th>#</th>
                      <th>Parameter Key</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>1.</td>
                      <td>status_code</td>
                      <td>
                        400 = Variable Related Error <br />
                        401 = Variable Data Related Error <br />
                        200 = Success
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>status_msg</td>
                      <td>
                        API Success or Error Message according status code.
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>status</td>
                      <td>
                        PENDING <br />
                        FAILED <br />
                        SUCCESS
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>txnid</td>
                      <td>Your Unique Trasaction ID.</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>rrn</td>
                      <td>rrn no from bank side.</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenMoneyPayoutDocument;
